// Latin Beginner Vocabulary - 50 unique items
// Each item supports 3 question types: target↔english, definition→target (no romanization)

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const latinBeginnerItems: VocabularyItem[] = [
  // Common Greetings & Phrases (1-10)
  {
    id: 'la-beg-001',
    target: 'salve',
    english: 'hello / greetings',
    definition: 'A common Latin greeting to one person',
    partOfSpeech: 'interjection'
  },
  {
    id: 'la-beg-002',
    target: 'vale',
    english: 'goodbye / farewell',
    definition: 'A farewell expression to one person',
    partOfSpeech: 'interjection'
  },
  {
    id: 'la-beg-003',
    target: 'gratias',
    english: 'thanks',
    definition: 'An expression of gratitude',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-004',
    target: 'ita',
    english: 'yes / so',
    definition: 'An affirmative response',
    partOfSpeech: 'adverb'
  },
  {
    id: 'la-beg-005',
    target: 'non',
    english: 'no / not',
    definition: 'A negative word',
    partOfSpeech: 'adverb'
  },
  {
    id: 'la-beg-006',
    target: 'et',
    english: 'and',
    definition: 'A conjunction connecting words',
    partOfSpeech: 'conjunction'
  },
  {
    id: 'la-beg-007',
    target: 'sed',
    english: 'but',
    definition: 'A conjunction showing contrast',
    partOfSpeech: 'conjunction'
  },
  {
    id: 'la-beg-008',
    target: 'quid',
    english: 'what',
    definition: 'An interrogative pronoun asking about things',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'la-beg-009',
    target: 'cur',
    english: 'why',
    definition: 'An interrogative asking for reason',
    partOfSpeech: 'adverb'
  },
  {
    id: 'la-beg-010',
    target: 'ubi',
    english: 'where',
    definition: 'An interrogative asking about place',
    partOfSpeech: 'adverb'
  },

  // Pronouns & People (11-20)
  {
    id: 'la-beg-011',
    target: 'ego',
    english: 'I',
    definition: 'First person singular pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'la-beg-012',
    target: 'tu',
    english: 'you (singular)',
    definition: 'Second person singular pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'la-beg-013',
    target: 'nos',
    english: 'we',
    definition: 'First person plural pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'la-beg-014',
    target: 'vos',
    english: 'you (plural)',
    definition: 'Second person plural pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'la-beg-015',
    target: 'vir',
    english: 'man',
    definition: 'An adult male human',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-016',
    target: 'femina',
    english: 'woman',
    definition: 'An adult female human',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-017',
    target: 'puer',
    english: 'boy',
    definition: 'A male child',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-018',
    target: 'puella',
    english: 'girl',
    definition: 'A female child',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-019',
    target: 'amicus',
    english: 'friend',
    definition: 'A person you know well and like',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-020',
    target: 'familia',
    english: 'family',
    definition: 'A group of related people',
    partOfSpeech: 'noun'
  },

  // Numbers (21-30)
  {
    id: 'la-beg-021',
    target: 'unus',
    english: 'one',
    definition: 'The number 1',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-022',
    target: 'duo',
    english: 'two',
    definition: 'The number 2',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-023',
    target: 'tres',
    english: 'three',
    definition: 'The number 3',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-024',
    target: 'quattuor',
    english: 'four',
    definition: 'The number 4',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-025',
    target: 'quinque',
    english: 'five',
    definition: 'The number 5',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-026',
    target: 'sex',
    english: 'six',
    definition: 'The number 6',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-027',
    target: 'septem',
    english: 'seven',
    definition: 'The number 7',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-028',
    target: 'octo',
    english: 'eight',
    definition: 'The number 8',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-029',
    target: 'novem',
    english: 'nine',
    definition: 'The number 9',
    partOfSpeech: 'number'
  },
  {
    id: 'la-beg-030',
    target: 'decem',
    english: 'ten',
    definition: 'The number 10',
    partOfSpeech: 'number'
  },

  // Common Nouns (31-40)
  {
    id: 'la-beg-031',
    target: 'aqua',
    english: 'water',
    definition: 'Clear liquid essential for life',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-032',
    target: 'terra',
    english: 'earth / land',
    definition: 'The ground or planet we live on',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-033',
    target: 'caelum',
    english: 'sky / heaven',
    definition: 'The space above the earth',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-034',
    target: 'domus',
    english: 'house / home',
    definition: 'A building where people live',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-035',
    target: 'liber',
    english: 'book',
    definition: 'Written pages bound together',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-036',
    target: 'canis',
    english: 'dog',
    definition: 'A domesticated animal that barks',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-037',
    target: 'equus',
    english: 'horse',
    definition: 'A large four-legged animal for riding',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-038',
    target: 'cibus',
    english: 'food',
    definition: 'Substances eaten for nourishment',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-039',
    target: 'vinum',
    english: 'wine',
    definition: 'An alcoholic drink made from grapes',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-beg-040',
    target: 'via',
    english: 'road / way',
    definition: 'A path for traveling',
    partOfSpeech: 'noun'
  },

  // Basic Verbs (41-50)
  {
    id: 'la-beg-041',
    target: 'esse',
    english: 'to be',
    definition: 'To exist or have identity',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-042',
    target: 'habere',
    english: 'to have',
    definition: 'To possess or hold something',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-043',
    target: 'amare',
    english: 'to love',
    definition: 'To have strong affection for',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-044',
    target: 'videre',
    english: 'to see',
    definition: 'To perceive with the eyes',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-045',
    target: 'audire',
    english: 'to hear',
    definition: 'To perceive sound with the ears',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-046',
    target: 'dicere',
    english: 'to say / to speak',
    definition: 'To communicate using words',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-047',
    target: 'venire',
    english: 'to come',
    definition: 'To move toward the speaker',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-048',
    target: 'ire',
    english: 'to go',
    definition: 'To move from one place to another',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-049',
    target: 'dare',
    english: 'to give',
    definition: 'To transfer possession to another',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-beg-050',
    target: 'facere',
    english: 'to do / to make',
    definition: 'To perform an action or create something',
    partOfSpeech: 'verb'
  }
];
